var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("script2", [
        _vm._v(
          "\n    _tsRatingConfig = {\n    tsid: 'X586585A7B0895E151A669F82C566BBEA',\n    variant: 'skyscraper_horizontal',\n    // valid values: 'vertical', 'skyscraper_horizontal', 'skyscraper_vertical', 'testimonial'\n    theme: 'light',\n    reviews: 10,\n    // default = 10\n    borderColor: '#d6d6d6',\n    // optional - overrides the border color\n    colorclassName: 'test',\n    // optional - override the whole sticker style with your own css class\n    introtext: 'What our customers say about us:',\n    // optional - not used in skyscraper and testimoinal variants\n    backgroundColor: '#ffdcof', fontColor: '#000000',\n    // optional - overrides background and font colors - only used for testimonial variant\n    richSnippets: 'off'\n    };\n    var scripts = document.getElementsByTagName('SCRIPT'),\n    me = scripts[scripts.length - 1];\n    var _ts = document.createElement('SCRIPT');\n    _ts.type = 'text/javascript';\n    _ts.async = true;\n    _ts.charset = 'utf-8';\n    _ts.src ='//widgets.trustedshops.com/reviews/tsSticker/tsSticker.js';\n    me.parentNode.insertBefore(_ts, me);\n    _tsRatingConfig.script = _ts;\n  "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block" }, [_vm._v(" ")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }